import { getAbTestLifecycleState } from '@bridebook/toolbox/src/ab-testing/lib/selectors';
import { CountryCodes } from '@bridebook/toolbox/src/gazetteer';
import { useABTestV2Integration } from '@bridebook/web/lib/ab-tests/hooks/use-ab-test-v2-integration';
import { IApplicationState } from '@bridebook/web/lib/types';
import { useSelector } from '@bridebook/web/lib/utils';

const testId = 'LIVE-27907_AppendIncompleteSearchResults';

export const getVariant_AppendIncompleteSearchResults = (state: IApplicationState) =>
  getAbTestLifecycleState(state, testId)?.variant;

export const useIsAppendIncompleteSearchEnabled = (slug?: string, countryCode?: CountryCodes) => {
  const variant = useSelector(getVariant_AppendIncompleteSearchResults);
  return variant === '1' && slug === 'venues' && countryCode === CountryCodes.GB;
};

export const useABTest_AppendIncompleteSearchResults = () => {
  useABTestV2Integration({ testId, triggerCondition: true });
};
